import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {CmsPagesPartialState} from './cmsPages.reducer';
import {CmsPagesQuery} from './cmsPages.selectors';
import * as CmsPagesActions from './cmsPages.actions';
import {ActionWithCorrelationAttributes} from '@kion/ngrx-helper';

@Injectable()
export class CmsPagesFacade {

  all$ = this.store.pipe(select(CmsPagesQuery.getAllCmsPages));
  allById$ = this.store.pipe(select(CmsPagesQuery.getAllCmsPagesById));
  searchResults$ = this.store.pipe(select(CmsPagesQuery.getSearchResults));
  isSearching$ = this.store.pipe(select(CmsPagesQuery.getIsSearching));
  lastCreatedId$ = this.store.pipe(select(CmsPagesQuery.getLastCreatedId));
  error$ = this.store.pipe(select(CmsPagesQuery.getError));
  actualPage$ = this.store.pipe(select(CmsPagesQuery.getActualPage));
  partnerLegals$ = this.store.pipe(select(CmsPagesQuery.getPartnerLegals));

  constructor(private store: Store<CmsPagesPartialState>) { }

  protected dispatch(action, correlationId?: string): ActionWithCorrelationAttributes {
    if (correlationId) {
      action.__correlationId = correlationId;
    }
    this.store.dispatch(action);
    return action;
  }

  loadPage(
    pageId: string,
    isTicket: boolean,
    cmsTicketId?: string,
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
      CmsPagesActions.loadCmsPage(
        {
          cmsPageId: pageId,
          isTicket: isTicket,
          cmsTicketId: cmsTicketId
        }
      ),
      correlationId
    )
  }

  loadProductPage(code: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(CmsPagesActions.loadProductCmsPage({code: code}), correlationId);
  }

  loadNetworkPartnerTermsAndConditionContent(nwpId: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(CmsPagesActions.loadNetworkPartnerTermsAndConditionsContent({nwpId}), correlationId);
  }

  loadNetworkPartnerPrivacyPolicyContent(nwpId: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(CmsPagesActions.loadNetworkPartnerPrivacyPolicyContent({nwpId}), correlationId);
  }

}
